import React, { useMemo } from 'react';
import { DeviceDetail } from '../../api/device';
import { LIGHT_ENUM, TipOwner } from '../../api/tips';
import TipsMountCard from '../material/TipsMountCard';

// 设备工况 › 加工小贴士区 (2026-08-27). 与材料详情页的小贴士卡片是同一个组件
// (TipsMountCard), 只是挂载对象换成设备 —— 挂载/拖拽排序/新建/分叉提示全套一致。
//
// 设备侧贴士是设备自身的注意事项 (清洁镜片 / 开排烟 / 装夹), 与材料侧挂载互不影响;
// 条目内容单源在小贴士库, 这里只做挂载与排序。

function DeviceTipsCard({ device }: { device: DeviceDetail }) {
    const owner: TipOwner = useMemo(() => {
        // 光源可选项按本机光源收窄 (capability.source 是 light_source 字典 code);
        // 取值不在贴士光源枚举里 (非激光设备等) 就不收窄, 由填写人自己判断。
        const src = device.capability?.source;
        const known = LIGHT_ENUM.some(([v]) => v === src);
        return {
            kind: 'device',
            key: device.deviceKey,
            name: device.name || device.deviceKey,
            lights: known && src ? [src] : undefined,
        };
    }, [device.deviceKey, device.name, device.capability?.source]);

    return <TipsMountCard owner={owner} />;
}

export default DeviceTipsCard;
